import { defineMessages } from 'react-intl'

// PrescriptionModal strings
export const prescriptionModalMessages = defineMessages({
  createTitle: {
    id: 'prescription.createTitle',
    defaultMessage: 'Create Prescription'
  },
  editTab: {
    id: 'prescription.editTab',
    defaultMessage: 'Edit Prescription'
  },
  previewTab: {
    id: 'prescription.previewTab',
    defaultMessage: 'Preview'
  },
  addMedication: {
    id: 'prescription.addMedication',
    defaultMessage: 'Add Medication'
  },
  additionalNotesPlaceholder: {
    id: 'prescription.additionalNotesPlaceholder',
    defaultMessage: 'Additional notes for the prescription'
  },
  close: {
    id: 'prescription.close',
    defaultMessage: 'Close'
  },
  previewButton: {
    id: 'prescription.previewButton',
    defaultMessage: 'Preview'
  },
  generatePdf: {
    id: 'prescription.generatePdf',
    defaultMessage: 'Generate PDF'
  },
  pdfGeneratedTitle: {
    id: 'prescription.pdfGeneratedTitle',
    defaultMessage: 'PDF Generated'
  },
  pdfGeneratedDescription: {
    id: 'prescription.pdfGeneratedDescription',
    defaultMessage: 'Prescription PDF has been created and downloaded.'
  },
  errorTitle: {
    id: 'prescription.errorTitle',
    defaultMessage: 'Error'
  },
  pdfErrorDescription: {
    id: 'prescription.pdfErrorDescription',
    defaultMessage: 'Failed to generate PDF. Please try again.'
  }
})

// PrescriptionPreview strings
export const prescriptionPreviewMessages = defineMessages({
  title: {
    id: 'prescription.preview.title',
    defaultMessage: 'Medical Prescription'
  },
  patientInfo: {
    id: 'prescription.preview.patientInfo',
    defaultMessage: 'Patient Information'
  },
  nameLabel: {
    id: 'prescription.preview.nameLabel',
    defaultMessage: 'Name:'
  },
  prescribedMedications: {
    id: 'prescription.preview.prescribedMedications',
    defaultMessage: 'Prescribed Medications'
  },
  numberHeader: {
    id: 'prescription.preview.numberHeader',
    defaultMessage: '#'
  },
  medicationHeader: {
    id: 'prescription.preview.medicationHeader',
    defaultMessage: 'Medication'
  },
  concentrationHeader: {
    id: 'prescription.preview.concentrationHeader',
    defaultMessage: 'Concentration'
  },
  quantityHeader: {
    id: 'prescription.preview.quantityHeader',
    defaultMessage: 'Quantity'
  },
  frequencyHeader: {
    id: 'prescription.preview.frequencyHeader',
    defaultMessage: 'Frequency'
  },
  durationHeader: {
    id: 'prescription.preview.durationHeader',
    defaultMessage: 'Duration'
  },
  specialInstructions: {
    id: 'prescription.preview.specialInstructions',
    defaultMessage: 'Special Instructions'
  },
  instructionsHeader: {
    id: 'prescription.preview.instructionsHeader',
    defaultMessage: 'Instructions'
  },
  doctorNotes: {
    id: 'prescription.preview.doctorNotes',
    defaultMessage: "Doctor's Notes"
  },
  signature: {
    id: 'prescription.preview.signature',
    defaultMessage: 'Signature'
  }
})

// MedicationRow strings
export const medicationRowMessages = defineMessages({
  specialInstructionsLabel: {
    id: 'prescription.specialInstructionsLabel',
    defaultMessage: 'Special Instructions'
  },
  medicationLabel: {
    id: 'prescription.medicationLabel',
    defaultMessage: 'Medication'
  },
  medicationPlaceholder: {
    id: 'prescription.medicationPlaceholder',
    defaultMessage: 'Medication name'
  },
  concentrationLabel: {
    id: 'prescription.concentrationLabel',
    defaultMessage: 'Concentration'
  },
  concentrationPlaceholder: {
    id: 'prescription.concentrationPlaceholder',
    defaultMessage: 'e.g. 500mg'
  },
  quantityLabel: {
    id: 'prescription.quantityLabel',
    defaultMessage: 'Quantity'
  },
  quantityPlaceholder: {
    id: 'prescription.quantityPlaceholder',
    defaultMessage: 'e.g. 30 tablets'
  },
  frequencyLabel: {
    id: 'prescription.frequencyLabel',
    defaultMessage: 'Frequency'
  },
  frequencyPlaceholder: {
    id: 'prescription.frequencyPlaceholder',
    defaultMessage: 'Select frequency'
  },
  durationLabel: {
    id: 'prescription.durationLabel',
    defaultMessage: 'Duration'
  },
  durationPlaceholder: {
    id: 'prescription.durationPlaceholder',
    defaultMessage: 'e.g. 7 days'
  },
  specialInstructionsPlaceholder: {
    id: 'prescription.specialInstructionsPlaceholder',
    defaultMessage: 'Special instructions'
  },
  removeMedicationAriaLabel: {
    id: 'prescription.removeMedicationAriaLabel',
    defaultMessage: 'Remove medication'
  }
})
